// src/components/logo/LogoMain.jsx
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { ThemeMode } from 'config';

import logoLight from 'assets/images/easy-messaging-new-logo.png';
import logoDark from 'assets/images/easy-messaging-new-logo.png';
export default function LogoMain({ reverse }) {
  const theme = useTheme();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  const isDark = reverse || theme.palette.mode === ThemeMode.DARK;
  const handleClickLogo = (e) => {
    if (isAdmin) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <img
      src={isDark ? logoDark : logoLight}
      alt="Easy Messaging"
      onClick={handleClickLogo} 
      style={{ display: 'flex', alignContent: 'left', justifyContent: 'left', height: 150, width: 150, cursor: isAdmin ? "default" : "pointer" }}
    />
  );
}
LogoMain.propTypes = { reverse: PropTypes.bool };
